import { render } from "./PcAppAlert.vue?vue&type=template&id=7af04146&scoped=true"
import script from "./PcAppAlert.vue?vue&type=script&lang=js"
export * from "./PcAppAlert.vue?vue&type=script&lang=js"

import "./PcAppAlert.vue?vue&type=style&index=0&id=7af04146&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7af04146"]])

export default __exports__